import { AfterViewInit, Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomEntityFieldComponent } from '../custom-entity-field/custom-entity-field.component';
import { DomSanitizer } from '@angular/platform-browser';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { Lightbox } from 'ngx-lightbox';
import { UserSessionService } from './../../../UserSession/user-session.service';
import { ReportsService } from './../../../apiclient/api/reports.service';
import { ExcelExporterService } from './../../../excel-exporter.service';
import * as moment from 'moment';
import { SubformComponent } from '../subform/subform.component';
import Map from 'ol/Map';
import Feature from 'ol/Feature';
import View from 'ol/View';
import {Point,Polygon} from 'ol/geom';
import {Style,Fill, Stroke} from 'ol/style';
import Icon from 'ol/style/Icon';
import OSM from 'ol/source/OSM';
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import Overlay from 'ol/Overlay';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import * as olExtent from 'ol/extent';
import * as olProj from 'ol/proj';
import Attribution from 'ol/control/Attribution';
import { GeometryEditorComponent } from './../../../components/geometry-editor/geometry-editor.component';
@Component({
  selector: 'ngx-customform',
  templateUrl: './customform.component.html',
  styleUrls: ['./customform.component.scss']
})
export class CustomformComponent implements OnInit,AfterViewInit {


  @ViewChild('geometrymapcontainer', {read: ElementRef})
  mapElement: ElementRef<HTMLElement>;

  map: Map;
  feature: Feature;
  vectorSource: VectorSource;

  sourcesList: any;

  customfields: any[] = []

  report: any = {};
  customform: any = {}

  editionEnabled: Boolean;

  subform: Boolean;

  dropdownSettings = {
    singleSelection: false,
    allowSearchFilter: true,
    searchPlaceholderText:"Buscar",
    enableCheckAll:false
  };

  dropdownSettingsSingle = {
    singleSelection: true,
    allowSearchFilter: true,
    searchPlaceholderText:"Buscar",
    enableCheckAll:false
  };

  @Input()
  set loadReport(val: any){
    if(null != val && val != undefined){
      console.log("Se carga el report")

      //Comprobamos si es un subform
      if(val.form_data != undefined){
        //Es un customform normal
        this.report = JSON.parse(JSON.stringify(val));
        this.subform = false
      }else{
        //Es un subform (Mantenemos la referencia para que se pueda guardar)
        this.report = val;
        this.subform = true;
      }

      this.initCustomform();
    }

  }

  @Input()
  set loadCustomform(val: any){
    console.log("Se carga el customform")
    this.customform = val

  }


  @Input()
  set enableEdition(enableEdition: any){
      this.editionEnabled = enableEdition;
      if(!this.editionEnabled && null != this.report  && null != this.customform){
        this.generateCustomFields();
      }
  }


  @ViewChildren("subformInstance") private subformsList: QueryList<SubformComponent>;

  async initCustomform(){
    await this.generateSourcesList()
    if(null != this.customform){
      this.generateCustomFields()
    }

  }

  constructor(private lightbox: Lightbox, private userSessionService: UserSessionService,
    private dialogService: NbDialogService, private sanitizer: DomSanitizer,
    private toastService: NbToastrService, private excelService: ExcelExporterService,
    private reportService: ReportsService) { }

  ngOnInit(): void {
  }



/**
   * Renderiza los campos del customform
   */
generateCustomFields(){
  this.customfields = [];
  if (this.customform.dynamic_form != undefined){
    this.customform.dynamic_form.Fields.forEach(f => {
      let key = f.id;
      let value = null;
      if(this.subform) {
        if(null != this.report[f.id]) {
          value = this.report[f.id]
        }
      }else{
        if(null != this.report.form_data[f.id]) {
          value = this.report.form_data[f.id]
        }
      }


      if (key !== 'location') {
        let customfield = this.getFieldData(key);
        if( customfield.type == 'picture'){
          customfield.imagen='';


            if (null != value && (value as String).startsWith('https://')){
              customfield.imagen = value;
            }else if(null != value && value != ''){
              customfield.imagen = 'https://api.smartrural.es:8084/v1/image/report' + value;
            }



          customfield.imagenth = customfield.imagen + '?th=true';
          customfield.value = value
        }else if (customfield.type == 'date' && value != null && value != ''){
          customfield.value = moment(value,'YYYY/MM/DD').toDate()

        }else if (customfield.type == 'date_range' && value != null && (value as any).from != null && (value as any).from != ''){
          customfield.value = {from:moment((value as any).from,'YYYY/MM/DD').toDate(),to:moment((value as any).to,'YYYY/MM/DD').toDate()};

        }else if (customfield.type == 'datetime_range' && value != null && (value as any).from != null && (value as any).from != ''){

          customfield.value = {from:moment((value as any).from,'YYYY/MM/DD HH:mm:ss').toDate(),to:moment((value as any).to,'YYYY/MM/DD HH:mm:ss').toDate()};

        }else if (customfield.type == 'datetime' && value != null && value != ''){

          customfield.value = moment(value,'YYYY/MM/DD HH:mm:ss').toDate()
        }else if (customfield.type == 'hour' && value != null){

          customfield.value = moment(value,'HH:mm:ss').toDate()
        }else if (customfield.type == 'field_list' && value != null){

          if (Array.isArray(value)){
            customfield.value = value
          }else{
            customfield.value = (value as String).split(',')
          }

          customfield.multiple = true
        }else if(customfield.type == 'number' && value != null){

          //customfield.value = Number(value)   Esther 19/01/2022
          customfield.value = Number(value).toFixed(2)

        }else if(customfield.type == 'customentity_list'){

          if(null != value && typeof value === 'object'){
            //Obtenemos las keys
            if (Array.isArray(value)){
              var strValues = [];
              value.forEach( v => {
                strValues.push(v[Object.keys(v).find(k => k!= 'id')])
              })
              customfield.value = strValues;
            }else{
              var valKey = Object.keys(value).find(k => k!= 'id');
              customfield.value = value[valKey]
            }

          }else{
            customfield.value = value;
          }
        }else if(customfield.type == 'subform'){
          customfield.value = value
        }else if (['select','user_list','product_list','field_list','machinery_list','region_list'].includes(customfield.type) && customfield.multiple != true){
          if (Array.isArray(value)){
            customfield.value = value
          }else{
            customfield.value = [value]
          }
            customfield.elements = customfield.elements.sort()
        }else{
          if(Array.isArray(value) && !customfield.multiple){
            customfield.value = value.join(',');
          }else{
            customfield.value = value;
          }

        }

        customfield.key = key;

        this.customfields.push(customfield);
      }else if(this.subform){
        let geometryField = this.getFieldData(key);
        geometryField.value = value;
        this.customfields.push(geometryField);

        setTimeout(()=>{
          this.initMap();
          this.loadLocation(geometryField.value);
        }, 750);



      }


  })

  this.customfields.sort((a,b) => (Number(a.pos) > Number(b.pos)) ? 1 : -1)

  console.log(this.customfields)
  }

}


  /**
   * Genera los listados de entidades
   */
  async generateSourcesList() {
    this.sourcesList = {}
    this.sourcesList['user_list'] = (await this.promisify(this.userSessionService.getCachedUsersList())).map(i => i.name+' '+i.surname)
    /*
    this.sourcesList['field_list'] = (await this.promisify(this.userSessionService.getCachedFieldList())).map(i => i.name)
    this.sourcesList['region_list'] = (await this.promisify(this.userSessionService.getCachedFieldList())).reduce((acc,f) => {
      if(!acc.includes(f.region)){
        acc.push(f.region)
      }
      return acc;
  },[]);

    this.sourcesList['product_list'] = (await this.promisify(this.userSessionService.getCachedProductList())).map(i => i.name)
    this.sourcesList['machinery_list'] = (await this.promisify(this.userSessionService.getCachedMachineryList())).map(i => i.name)
  */
  }

  /**
   * @ignore
   * @param obs
   * @returns
   */
  async promisify(obs: Observable<any>): Promise<any> {
    return new Promise((resolve,reject) => {
        obs.subscribe(d => {
          resolve(d);
        },error => {
          reject(error)
        })
    })
  }




   /**
    * @ignore
    * @param archivos
    * @param item
    */
   actualizarImagen(archivos: FileList,item: any){


    item.imagen = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(archivos.item(0)));
    item.imagenth = item.imagen
    const file = archivos.item(0)
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {

        item.value = 'dataImageName:/'+this.userSessionService.user.company.id+'/'+this.userSessionService.user.id+'/'+file.name+';'
        + (reader.result as String).split(',')[1]
        console.log(reader.result);
    };

  }


  onCustomEntityChangeValue(event: any){

    event.executionTimestamp = new Date().getMilliseconds();

    console.log(event);
    //Chequeamos los dependency groups
    //Obtenemos los grupos de dependencias en los que el campo está incluido
    let depGroups =this.customform.dynamic_form.dependencyGroups.filter(gr => gr.includes(event.sourceField));


    if(event.depGroups == undefined){
      event.depGroups = {current:'',groups:{}};

    }



    //REcorremos los grupos de dependencias objetivo
    depGroups.forEach((group,indexGroup) => {
      if(event.depGroups.groups[group.join('_')] == undefined){
        event.depGroups.groups[group.join('_')] = {elements: group, selectedValues:{}};
      }

      //event.depGroups.groups[group.join('_')].selectedValues[event.sourceField] = event.values;

      //TODO: Hay que obtener los valores que pudieran tener el resto de campos del grupo

      if(event.values.length > 0){
          group/*.filter( f => f != event.sourceField)*/.forEach((f,index) => {

            let customField = (this.customfields.find(ft => ft.key == f ).componentRef as CustomEntityFieldComponent);

            if(customField.userSelected || event.sourceField == f) {
              let value = customField.getValueForDependencyGroups();

              if(value != null && value.length > 0 && value[0] != ''){
                event.depGroups.groups[group.join('_')].selectedValues[f] = value;
              }else{
                event.depGroups.groups[group.join('_')].selectedValues[f] = event.values;
              }
            }
          });
      }
      var posOrigin = group.indexOf(event.sourceField)

      //Recorremos los campos en los que hay que propagar el evento excluyendo el campo que origina el evento
      event.depGroups.current = group.join('_');

      group.filter( f => f != event.sourceField).forEach((f,indexf) => {


            //Obtenemos el campo destino
            let targetField = this.customfields.find(ft => ft.key == f );

            //Si el campo de destino no es el mismo campo que originó el evento disparamos el evento
            if( (event.impactedFields == undefined || !event.impactedFields.includes(targetField.key))
             &&  (event.originField == undefined || event.originField != targetField.key)){

              var selectedValues = [];



                Object.keys( event.depGroups.groups[group.join('_')].selectedValues)
                .filter(fk => fk != f).forEach(fk => {
                  var valores = event.depGroups.groups[group.join('_')].selectedValues[fk];

                  if(selectedValues.length > 0 && valores.length > 0){
                    //Ya hay valores. Sólo dejamos los que coincidan
                    var consolidatedValues = [];

                    valores.forEach(element => {
                      if(selectedValues.find(e => e.id == element.id) != null){
                        consolidatedValues.push(element);
                      }
                    });
                    selectedValues = consolidatedValues;
                  }else{
                    selectedValues = selectedValues.concat(valores);
                  }

                });

                //Evitamos los duplicados

                selectedValues = selectedValues.filter((v,i,a)=>a.findIndex(v2=>(v2.id===v.id))===i);




              (targetField.componentRef as CustomEntityFieldComponent).
              triggerChangeValue(Object.assign(event,{onCascade: indexf > posOrigin,
                values: selectedValues}));

                /*
              Object.keys( event.depGroups.groups[group.join('_')].selectedValues)
              .filter(fk => fk != f).forEach(fk => {
                (targetField.componentRef as CustomEntityFieldComponent).
                triggerChangeValue(Object.assign(event,{onCascade: indexf > posOrigin,
                  values: event.depGroups.groups[group.join('_')].selectedValues[fk]}));
              });
              ;
*/

            }


      });

    })

  }

  formatDate(date:string,format:string){
    var r = moment(date).format(format);
    if (r == 'Invalid date') r = '';
    return r;
  }


    /**
   * Abre la imagen
   * @param i
   */
    open(i){
      console.log("Queremos abrir la imagen "+i);
      var fotos = [{src:i,thumb:i}]
      this.lightbox.open(fotos,0);
    }

    /**
     * Obtiene los datos de un determinado campo del customform
     * @param fieldid id del campo
     * @returns
     */
    getFieldData(fieldid): any{

      //console.log(this.customform)
      //console.log(fieldid)

      let field = this.customform.dynamic_form.Fields.find( e => e.id === fieldid)
      if (field.type == 'field_list' || field.type == 'region_list' || field.type == 'product_list' || field.type == 'machinery_list' || field.type == 'user_list'){
        field.elements = this.sourcesList[field.type]
      }

      //console.log(field);
      if(field != undefined){
        return {title:field.title,type:field.type,pos:field.pos,elements:field.elements,
          multiple:field.multiselect,customEntityConfig:field.customEntityConfig,subformConfig:field.subformConfig,key:fieldid};
      }else{
        return {title:fieldid,type:'text',pos:100};
      }

    }


    saveReport(): any {
      let reportToSave = {}
      this.customfields.forEach(f => {

        if (f.type == 'number'){
          reportToSave[f.key] = String(f.value)
        }else if(f.type =='hour'){
          reportToSave[f.key] = moment(moment(f.value,moment.ISO_8601).toDate()).format('HH:mm:ss')
        }else if (['select','user_list','product_list','field_list','machinery_list'].includes(f.type) && f.multiple != true){
          reportToSave[f.key] =f.value[0]

        }else if(f.type =='customentity_list'){
          reportToSave[f.key] = f.componentRef.getSelectedValues();
          if(f.multiple != true && reportToSave[f.key] != undefined && reportToSave[f.key] != null){
            reportToSave[f.key] = reportToSave[f.key][0];
          }
        }else if(f.type =='subform'){
          reportToSave[f.key] = this.subformsList.find(s => s.fieldId == f.key).getValue();
        }else{
          reportToSave[f.key] = f.value
        }

      })

      return reportToSave;
    }



    ngAfterViewInit(): void {
        var geometryField = this.customfields.find(cf => cf.type === 'location');
        if(geometryField != undefined && geometryField != null){
                  //Es un location

        setTimeout(()=>{
          this.initMap();
          this.loadLocation(geometryField);
        }, 750);
        }
    }

    async editGeometry(fieldRef: string){
      var editorref = await  this.dialogService.open(GeometryEditorComponent);

      editorref.componentRef.instance.cargarGeometria(this.report[fieldRef].geometry);


      editorref.componentRef.instance.getGeometry().subscribe( geo => {
        if (null != geo){
          console.log(geo);
          let valueToSave = {type:'Feature',geometry:geo};
          this.customfields.find(cf => cf.key === fieldRef).value = valueToSave;

          this.vectorSource.clear();
          this.loadLocation(valueToSave);
        }else{
          this.vectorSource.clear();
        }

      });
    }


    initMap() {

      this.vectorSource = new VectorSource();
      const attribution = new Attribution({
        html: 'Teselas de PNOA cedido por � Instituto Geogr�fico Nacional de Espa�a'
      });

      let projection = olProj.get('EPSG:3857');
      let projectionExtent = projection.getExtent();
      //var size = ol.extent.getWidth(projectionExtent) / 512;
      let size = olExtent.getWidth(projectionExtent) / 256;
      let resolutions = new Array(18);
      let matrixIds = new Array(18);
      for (var z = 0; z < 18; ++z) {
        // generate resolutions and matrixIds arrays for this WMTS
        resolutions[z] = size / Math.pow(2, z);
        //matrixIds[z] = "EPSG:4326:" + z;
        matrixIds[z] = z;
      }

      this.map = new Map({
        target: this.mapElement.nativeElement,
        layers: [
          new TileLayer({
        source: new OSM(),
      }) ,
      new TileLayer({
        visible: true,
        title: 'Mapa Geográfico',
        type:'base',
        source: new WMTS({
          attributions:
            'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/' +
            'services/Demographics/USA_Population_Density/MapServer/">ArcGIS</a>',
          url:
            'https://server.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/WMTS/',
          layer: '0',
          matrixSet: 'EPSG:3857',
          format: 'image/png',
          projection: projection,
          tileGrid: new WMTSTileGrid({
            origin: olExtent.getTopLeft(olProj.get('EPSG:3857').getExtent()),
            resolutions: resolutions,
            matrixIds: matrixIds,
          }),
          style: 'default',
          wrapX: true,
        }),
      }),
          new VectorLayer({
            source: this.vectorSource,
          }),
        ],
        view: new View({
          //center: olProj.fromLonLat(this.config.center),
          zoom: 5,
        })
      });

      console.log("Mapa inicializado")
    }


    loadLocation(location: any) {
      console.log("Cargar localizacion")
      console.log(location)



      if (typeof location != 'undefined'){
        var coordinates = [];

        coordinates = location.geometry.coordinates;


        var feature = JSON.parse(JSON.stringify(location));


        console.log(feature)

        if (feature.geometry.type == "Polygon"){
            feature.geometry.coordinates[0] = feature.geometry.coordinates[0].map(function(coordinate){
              return olProj.fromLonLat(coordinate);
            });

            coordinates = location.geometry.coordinates[0][0];
        }else{
          feature.geometry.coordinates = olProj.fromLonLat(feature.geometry.coordinates)

        }
        console.log(feature)
        var olfeature = new GeoJSON().readFeature(feature)
        console.log(olfeature);

      var iconFeature = new Feature({
        geometry: olfeature.getGeometry(),
        name: this.report.diseaseName,

        informe: this.report,
      });



      if (feature.geometry.type == "Polygon"){
        olfeature.setStyle(new Style({
          stroke: new Stroke({
            color: 'blue',
            width: 1,
          }),
          fill: new Fill({
            color: 'rgba(0, 0, 255, 0.1)',
          }),
        }))

      }else{
        olfeature.setStyle(new Style({
          image: new Icon({
            color: '#32CD32',
            crossOrigin: 'anonymous',
            src: 'assets/images/marker_sampling.png',
            scale: 0.5,
          }),
        }));
      }




          console.log(olfeature)
          this.vectorSource.addFeature(olfeature);


          this.map.getView().setCenter(olProj.fromLonLat(coordinates));


          this.map.getView().setZoom(15);
      }




    }
}
